import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const initialState = {
    constants: null,
};

export const constantsSlice = createSlice({
    name: "constants",
    initialState,
    reducers: {
        updateConstants: (state, action) => {
            state.constants = action.payload;;
        },
    },
});

export const {
    updateConstants,
} = constantsSlice.actions;

export default constantsSlice.reducer;